import classNames from 'classnames';
import { forwardRef } from 'react';
const locationIconColorKindPhysicalCss = "lrxml4o";
const locationIconColorKindInboundCallCss = "l1lvk6xt";
const locationIconColorKindOutboundCallCss = "l1ucyauh";
const locationIconColorKindCustomCss = "lbqufme";
const locationIconColorKindAskInviteeCss = "lj6hrf";
const locationIconColorCss = "l1ej0pz7";
export const LocationIconColor = forwardRef((props, ref) => {
  const {
    kind,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(locationIconColorCss, {
    [locationIconColorKindPhysicalCss]: kind?.toString() === 'physical',
    [locationIconColorKindInboundCallCss]: kind?.toString() === 'inbound_call',
    [locationIconColorKindOutboundCallCss]: kind?.toString() === 'outbound_call',
    [locationIconColorKindCustomCss]: kind?.toString() === 'custom',
    [locationIconColorKindAskInviteeCss]: kind?.toString() === 'ask_invitee'
  }, props.className)} />;
});

require("./location_icon_color.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_icon_color.js");